import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import {
    putLogin,
    postRegisterSeller
} from './rest'
import { toast } from 'react-toastify'
import { errorToastMap } from 'redux/helpers'

const SESSION_KEY = 'SESSION'

export const fetchSignup = createAsyncThunk('root/fetchSignup',
    async function (data: { phone: string, mail: string, password: string }, { rejectWithValue, dispatch }) {
        try {

            const result = await postRegisterSeller(data)

            if (result?.status !== 200) {
                errorToastMap(result.data.message)
                return rejectWithValue('Ошибка код не 200')
            }

            return result
        }

        catch (err) {
            toast.error('Ошибка регистрации')
            return rejectWithValue(err)
        }
    })


export const fetchLogin = createAsyncThunk('root/fetchLogin',
    async function (data: { phone: string, password: string }, { rejectWithValue }) {
        try {
            const result = await putLogin(data)

            if (result?.status !== 200) {
                errorToastMap(result.response.message)
                return rejectWithValue('Ошибка код не 200')
            }

            return result
        }

        catch (err) {
            console.log('fetchLogin/error', err)
            toast.error('Ошибка запроса')
            return rejectWithValue(err)
        }
    }
)

export interface RootState {
    theme: 'white' | 'yellow' | 'pink' | 'green' | 'blue',
    isLoading: boolean,
    account: string,
    isMetamaskLogin: boolean,
    signupStep: number,
    session: string | null,
    error: string | null,
}

const initialState: RootState = {
    theme: 'blue',
    isLoading: false,
    account: null,
    isMetamaskLogin: false,
    signupStep: 1,
    session: localStorage.getItem(SESSION_KEY),
    error: null,
}


export const rootSlice = createSlice({
    name: 'root',
    initialState,
    reducers: {
        cancelAuth: (state) => {
            state.session = null;
            localStorage.removeItem(SESSION_KEY);
        },
        nextStep: (state) => {
            state.signupStep = state.signupStep + 1
        },
        previousStep: (state) => {
            state.signupStep = state.signupStep - 1
        },
        updateTheme: (state, action) => {
            state.theme = action.payload
        },
        updateAccount: (state, action) => {
            state.account = action.payload
        },
        deleteAccount: (state) => {
            state.account = null
        },

    },
    extraReducers: (builder) => {
        // Signup
        builder.addCase(fetchSignup.pending, (state) => {
            state.isLoading = true
        })
        builder.addCase(fetchSignup.fulfilled, (state, action) => {
            localStorage.setItem(SESSION_KEY, action.payload.data.token);
            state.session = localStorage.getItem(SESSION_KEY)
            state.isLoading = false;
        })
        builder.addCase(fetchSignup.rejected, (state, action) => {
            state.isLoading = false;
        })

        // Login
        builder.addCase(fetchLogin.pending, (state) => {
            state.isLoading = true;
        })
        builder.addCase(fetchLogin.fulfilled, (state, action) => {
            localStorage.setItem(SESSION_KEY, action.payload.response.token);
            state.session = localStorage.getItem(SESSION_KEY)
            state.isLoading = false;
        })
        builder.addCase(fetchLogin.rejected, (state, action) => {
            state.isLoading = false;
        })

    },
})

export const {
    cancelAuth,
    nextStep,
    previousStep,
    updateTheme,
    updateAccount,
    deleteAccount } = rootSlice.actions
export default rootSlice.reducer
